import { IconSVG } from '../types';

export const Add = ({ size, style }: IconSVG) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size}
      height={size}
      style={style}
      fill="none" 
      viewBox="0 0 18 18">
      <path
        fill="currentColor"
        d="M8.25 9.75H4.5a.73.73 0 0 1-.534-.216A.73.73 0 0 1 3.75 9q0-.319.216-.534A.73.73 0 0 1 4.5 8.25h3.75V4.5q0-.319.216-.534A.73.73 0 0 1 9 3.75q.319 0 .534.216a.73.73 0 0 1 .216.534v3.75h3.75q.319 0 .534.216A.73.73 0 0 1 14.25 9q0 .319-.216.534a.73.73 0 0 1-.534.216H9.75v3.75q0 .319-.216.534A.73.73 0 0 1 9 14.25a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534z"
       />
    </svg>
  );
};
